import { createAction } from '@reduxjs/toolkit';

import {
  CLOSE_MOBILE_MENU,
  SET_SHOW_USAGE,
  TOGGLE_MOBILE_MENU,
  TOGGLE_SHOW_USAGE,
  TOGGLE_SIDEBAR,
} from './constants';

export const toggleSidebar = createAction(TOGGLE_SIDEBAR);
export const toggleMobileMenu = createAction(TOGGLE_MOBILE_MENU);
export const closeMobileMenu = createAction(CLOSE_MOBILE_MENU);
export const toggleShowUsage = createAction(TOGGLE_SHOW_USAGE);
export const setShowUsage = createAction<
  boolean |((prevState: boolean) => boolean)
    >(SET_SHOW_USAGE);
